import { foregroundOn, initialOf } from "../tokens/palette.js";
import type { Person } from "../lib/types.js";

/**
 * The person filter. An event shows if any of its people are selected; an empty
 * selection means everyone, which is the resting state.
 */
export function WhoFilter({
  people,
  selected,
  onToggle,
  onClear,
}: {
  people: Person[];
  selected: string[];
  onToggle: (id: string) => void;
  onClear: () => void;
}): React.JSX.Element {
  return (
    <div className="who">
      {people.map((person) => {
        const on = selected.includes(person.id);
        return (
          <button
            key={person.id}
            type="button"
            className={`chip${on ? " is-on" : ""}`}
            aria-pressed={on}
            onClick={() => onToggle(person.id)}
            style={
              on
                ? { background: person.color, color: foregroundOn(person.color), borderColor: person.color }
                : undefined
            }
          >
            <span
              className="disc chip__disc"
              style={
                on
                  ? { background: foregroundOn(person.color), color: person.color }
                  : { background: person.color, color: foregroundOn(person.color) }
              }
            >
              {initialOf(person.display_name)}
            </span>
            {person.display_name}
          </button>
        );
      })}

      {selected.length > 0 && (
        <button type="button" className="who__clear" onClick={onClear}>
          Everyone
        </button>
      )}
    </div>
  );
}
